

    import * as T from '@/catalog-app/types';
    import { defineComponent, reactive } from 'vue';
    import { useStore } from '@/catalog-app/store';
    import { toTitleCase } from '@/utils';
    import Breadcrumbs from '@/catalog-app/components/Breadcrumbs.vue';
    import Panel from '@/catalog-app/components/Panel.vue';

    export default defineComponent({

        components: {
            Breadcrumbs,
            Panel,
        },

        setup() { // props

            const store = useStore();
            const state = store.state;

            // load data from django
            // eslint-disable-next-line
            const data = JSON.parse(document.getElementById('catalog-app-data')!.textContent!);
            store.initialize(data);

            // initialize banner
            const banner = reactive({
                title: data.title,
                description: data.description,
                img: data.img,
                imgB: data.img_b,
            } as T.Banner);

            // event handler for Catalog component child
            const updateBanner = (b: T.Banner) => {
                Object.assign(banner, b);
            };

            return {
                state,
                banner,
                updateBanner,
            }
        },

        computed: {

            contactURL(): string {
                return `/contact-us/`;
                // const store = useStore();
                // if (store.state.brand) {
                //     return `/contact-us/?brand=${store.state.brand.name}`;
                // } else {
                //     return `/contact-us/`;
                // }
            },

            catalogName(): string {
                const c = this.$route.params.catalog as string;
                if (c) {
                    return toTitleCase(c.replace('-', ' '));
                } else {
                    return '';
                }
            },

            categoryBreadcrumbs(): T.Breadcrumb[] {

                if (this.$route.params.category) {
                    const builtPath = [];
                    const breadcrumbs = [];
                    for(const p of this.$route.params.category as string[]) {
                        builtPath.push(p);
                        breadcrumbs.push({
                            'categories': [...builtPath],
                            'path': builtPath.join('/'),
                            'name': toTitleCase(p.replace('-', ' ')),
                            'last': builtPath.length === this.$route.params.category.length,
                        });
                    }

                    return breadcrumbs;
                }

                return [];

            }
        },
        methods: {

        },

    });

